import { IPG } from "@/types/summary";
import { v4 as uuidV4 } from "uuid";

export const getParaInfo = (
  para: IPG,
  scFilterFn?: (item: IPG["sc"][0]) => boolean
) => {
  let sc = para.sc;
  if (scFilterFn) {
    sc = sc.filter((item) => scFilterFn(item));
  }
  const flatWords = sc?.flatMap((scItem) => scItem.words);
  return {
    content: flatWords.map((wordItem) => wordItem.word).join(""),
    bt: sc[0]?.bt,
    et: sc[sc.length-1]?.et,
  };
};

export function splitPara(
  ipg: IPG,
  wi: string,
  si: string,
  cIndex?: number
): [IPG, IPG] {
  let prevWordContent = "";
  let nextWordContent = "";
  let splitTime = 0;
  let bt = 0;
  let et = 0;
  let mark = false;
  let splitWIndex = 0;
  const splitSIndex = ipg.sc.findIndex((s) => s.si === si);
  const targetSent = ipg.sc[splitSIndex];
  if (!targetSent || targetSent.words.length === 0) {
    const { bt: ipgBt, et: ipgEt } = ipg;
    if (ipgBt && ipgEt) {
      bt = ipgBt;
      splitTime = bt;
      et = ipgEt;
    }
  } else {
    splitWIndex = targetSent.words.findIndex((word) => word.wi === wi);
    const targetWord = targetSent.words[splitWIndex];
    const { bt: targetBt, et: targetEt, word, mark: targetMark } = targetWord;
    bt = targetBt;
    et = targetEt;
    // 找不到word时，word为undefined
    const averageCT = (et - bt) / (word?.length || 1);
    prevWordContent = word.slice(0, cIndex);
    splitTime = bt + prevWordContent.length * averageCT;
    mark = targetMark;
    nextWordContent = word.slice(cIndex);
  }
  const prevWord = {
    word: prevWordContent,
    bt,
    et: splitTime,
    wi,
    mark,
  };
  const nextWord = {
    word: nextWordContent,
    bt: splitTime,
    et,
    wi: `w-${uuidV4()}-2`,
    mark,
  };
  // 深拷贝原始对象，避免直接修改
  const ipgCopy1: IPG = JSON.parse(JSON.stringify(ipg));
  const ipgCopy2: IPG = JSON.parse(JSON.stringify(ipg));

  ipgCopy1.sc = ipgCopy1.sc.slice(0, splitSIndex + 1 >=1  ? splitSIndex + 1 : 1);

  const ipgCopy1LastSc = ipgCopy1.sc[ipgCopy1.sc.length - 1];
  ipgCopy1LastSc.words = ipgCopy1LastSc.words.slice(0, splitWIndex);
  ipgCopy1LastSc.words.push(prevWord);

  ipgCopy2.sc = ipgCopy2.sc.slice(splitSIndex);
  const ipgCopy2FirstSc = ipgCopy2.sc[0];
  // 这里暂时不需要操作到句子的bt、et和mark，所以只对id、pi、si进行修改
  ipgCopy2.pi = `p-${uuidV4()}`;
  ipgCopy2FirstSc.si = `s-${uuidV4()}`;
  ipgCopy2FirstSc.words = ipgCopy2FirstSc.words.slice(splitWIndex + 1);
  ipgCopy2FirstSc.words.unshift(nextWord);

  return [ipgCopy1, ipgCopy2];
}

// 示例数据
// const ipg: IPG = {
//   role: "old role",
//   roleName: "new role",
//   speakerName: ["Alice", "Bob"],
//   sc: [
//     {
//       bt: 0,
//       et: 10,
//       tc: "some text",
//       id: 1,
//       mark: false,
//       si: "1",
//       words: [
//         { word: "hello", bt: 0, et: 1, wi: "1" },
//         { word: "world", bt: 1, et: 2, wi: "2" },
//         { word: "foo", bt: 2, et: 3, wi: "3" },
//         { word: "bar", bt: 3, et: 4, wi: "4" },
//       ],
//     },
//     {
//       bt: 11,
//       et: 20,
//       tc: "some text2",
//       id: 2,
//       mark: false,
//       si: "2",
//       words: [
//         { word: "xxxxx", bt: 0, et: 1, wi: "21" },
//         { word: "yyyyy", bt: 1, et: 2, wi: "22" },
//         { word: "zzzzz", bt: 2, et: 3, wi: "23" },
//         { word: "wwwww", bt: 3, et: 4, wi: "24" },
//       ],
//     },
//     {
//       bt: 21,
//       et: 30,
//       tc: "some text2",
//       id: 3,
//       mark: false,
//       si: "3",
//       words: [
//         { word: "xxxxx2", bt: 0, et: 1, wi: "421" },
//         { word: "yyyyy3", bt: 1, et: 2, wi: "422" },
//         { word: "zzzzz3", bt: 2, et: 3, wi: "423" },
//         { word: "wwwww3", bt: 3, et: 4, wi: "424" },
//       ],
//     },
//   ],
//   mark: false,
//   id: 1,
//   pi: "1",
// };

// // 根据 wi 划分
// const [ipgPart1, ipgPart2] = splitPara(ipg, "1", "1", 0);
// console.log(8999, ipgPart1, ipgPart2);

export function  findLastConsecutiveNumber(arr: number[], target: number){
  // 从后往前遍历数组
  for (let i = arr.length - 1; i > 0; i--) {
    // 检查当前数字是否与前一个数字连续
    if (arr[i] === target && arr[i] - arr[i - 1] > 1) {
      return arr[i - 1];
    }
  }
  return target;
}

export function isEqualContent(para1: IPG, para2Content: string){
  const p1Content =  para1.sc
  .flatMap(s => s.words)
  .map(w => w.word)
  .join('');
  return p1Content === para2Content;
}